export default __webpack_public_path__ + "static/media/image.301316d5.jpg";